import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import styled, { ThemeProvider, keyframes } from 'styled-components'
import tw from 'tailwind.macro'
import { MdClose } from 'react-icons/md'
import theme from '@/shared/theme'

const Button = styled.a`
  font-size: 16px;
  border-radius: 4px;
  color: ${props => props.theme.white};
  background-color: ${props => props.theme.primary};
  padding: 13px 20px;
  min-width: 140px;
  text-decoration: none;
  display: inline-block;
`

const Container = styled.div`
  ${tw`pin fixed`};
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999999;
`

const Popup = styled.div`
  position: absolute;
  width: 90%;
  max-width: 420px;
  z-index: 2;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  z-index: 99;
  perspective: 1600px;
  transform: translate3d(-50%, -50%, 0);
`

const flip = keyframes`
  from{
    transform: rotateY(70deg);
    opacity:0;
  }
  
  to{
    transform: rotateY(0deg);
    opacity:1;

  }
`

const PopupContent = styled.div`
  background-color: ${props => props.theme.white};
  border-radius: 20px;
  transform-style: preserve-3d;
  transform: rotateY(70deg);
  text-align: center;
  opacity: 0;
  padding: 40px 30px;
  transform: rotateY(0);
  opacity: 1;
  animation: ${flip} 0.4s ease-in-out;
`

const CloseButton = styled.button`
  font-size: 24px;
  border: none;
  background-color: transparent;
  position: absolute;
  right: 20px;
  top: 20px;
`

const Modal = ({ onClose }) => {
  const closeByEsc = e => {
    if (e.key === 'Escape') {
      onClose()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', closeByEsc)

    return () => {
      document.removeEventListener('keydown', closeByEsc)
    }
  })
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Popup
          role="dialog"
          id="dialog"
          aria-describedby="dialog_desc"
          aria-modal="true"
        >
          <PopupContent>
            <CloseButton onClick={onClose}>
              <MdClose />
            </CloseButton>
            <p className="mb-8" id="dialog_desc">
              You will be redirected to{' '}
              <b className="font-semibold">ondemandassessment.com</b> to take a
              test. Please submit a valid email to receive our interview
              invitation in case you pass the test.
            </p>

            <Button href="https://www.ondemandassessment.com/link/index/JB-YOJUNNROE?u=134145">
              Take the test
            </Button>
          </PopupContent>
        </Popup>
      </Container>
    </ThemeProvider>
  )
}

const showApplyPopup = () => {
  let holder

  const openVideo = () => {
    holder = document.createElement('div')
    document.body.appendChild(holder)
    document.body.style.overflow = 'hidden'
    ReactDOM.render(<Modal onClose={close} />, holder)
  }

  const close = () => {
    if (holder) {
      document.body.style.overflow = ''
      document.body.removeChild(holder)
      holder = undefined
    }
  }

  return openVideo
}

export default showApplyPopup
